// extracted by mini-css-extract-plugin
export var standaloneTable = "_i1-0";
export var standaloneTableWithBodyFill = "_i1-1";
export var withExtraHeader = "_i1-2";